import http from '@/requests/http'

class ConsultationCustomField {
  static all (params) {
    return http.post('configuration/consultation/custom-field/index', params)
  }
  static async view (params) {
    return http.post('configuration/consultation/custom-field/view', params)
  }
  static async update (data) {
    return http.post('configuration/consultation/custom-field/update', data)
  }
  static async save (data) {
    return http.post('configuration/consultation/custom-field/store', data)
  }
  static async delete (id) {
    return http.post(`configuration/consultation/custom-field/delete/${id}`)
  }
}

export default ConsultationCustomField
